<template>
  <div>
    <div>
      <el-form ref="voucherHeadData" :model="voucherHeadData" :rules="rules">
        <div class="item">
          <el-form-item label="模块名字">
            <el-select
              v-model="voucherHeadData.applicationCode"
              @change="changeApplication"
              placeholder="请选择"
            >
              <el-option
                v-for="item in applicationCodeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.enableFlag !== '1'"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单据名称">
            <el-select
              v-model="voucherHeadData.entityCode"
              placeholder="请选择"
              @change="changeBill"
              :disabled="billDisabled"
            >
              <el-option
                v-for="item in billOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单据事件名称" prop="eventCode">
            <!--<el-input v-model="voucherHeadData.eventCode"></el-input>-->
            <el-select
              v-model="voucherHeadData.eventCode"
              placeholder="请选择"
              :disabled="eventCodeDisabled"
            >
              <el-option
                v-for="item in eventCodeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="凭证模板编码" prop="templateCode">
            <el-input v-model="voucherHeadData.templateCode"></el-input>
          </el-form-item>
          <el-form-item label="凭证模板名称">
            <el-input v-model="voucherHeadData.templateName"></el-input>
          </el-form-item>
          <el-form-item label="凭证模板描述" class="check-box">
            <el-input v-model="voucherHeadData.templateDesc"></el-input>
          </el-form-item>
          <el-form-item label="启用">
            <el-select v-model="voucherHeadData.enableFlag" placeholder="请选择">
              <el-option label="是" value="Y"> </el-option>
              <el-option label="否" value="N"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>凭证头定义</div>
        <div class="item">
          <el-form-item label="账套编码">
            <el-input v-model="voucherHeadData.ledgerCode"></el-input>
          </el-form-item>
          <el-form-item label="交易方代码">
            <el-input v-model="voucherHeadData.voucherCompanyCode"></el-input>
          </el-form-item>
          <el-form-item label="交易方名称">
            <el-input v-model="voucherHeadData.voucherCompanyName"></el-input>
          </el-form-item>
          <el-form-item label="凭证类型">
            <el-input v-model="voucherHeadData.voucherType"></el-input>
          </el-form-item>
          <el-form-item label="参考编号">
            <el-input v-model="voucherHeadData.referenceNo"></el-input>
          </el-form-item>
          <el-form-item label="本位币种" class="check-box">
            <el-input v-model="voucherHeadData.companyCurrencyCode"></el-input>
          </el-form-item>
          <el-form-item label="汇率类型">
            <el-input v-model="voucherHeadData.exchangeType"></el-input>
          </el-form-item>
          <el-form-item label="汇率值">
            <el-input v-model="voucherHeadData.exchangeRate"></el-input>
          </el-form-item>
          <el-form-item label="汇率日期">
            <el-input v-model="voucherHeadData.exchangeDate"></el-input>
          </el-form-item>
          <el-form-item label="业务单据ID">
            <el-input v-model="voucherHeadData.entityDataId"></el-input>
          </el-form-item>
          <el-form-item label="业务单据编号">
            <el-input v-model="voucherHeadData.entityDataNo"></el-input>
          </el-form-item>
          <el-form-item label="业务币种">
            <el-input v-model="voucherHeadData.currencyCode"></el-input>
          </el-form-item>
          <el-form-item label="凭证日期">
            <el-input v-model="voucherHeadData.voucherDate"></el-input>
          </el-form-item>
          <el-form-item label="过账日期">
            <el-input v-model="voucherHeadData.postDate"></el-input>
          </el-form-item>
          <el-form-item label="会计条件">
            <el-input v-model="voucherHeadData.accountCondition"></el-input>
          </el-form-item>
          <el-form-item label="摘要">
            <el-input v-model="voucherHeadData.entityUrl"></el-input>
          </el-form-item>
          <el-form-item label="业务单据链接">
            <el-input v-model="voucherHeadData.summary"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'voucherHead',
    props: {
      formData: {
        type: Object,
      },
    },
    watch: {
      formData(newValue) {
        this.voucherHeadData = newValue;
        if (this.$route.query.type === 'edit') {
          this.loadBill(this.voucherHeadData.applicationCode);
          this.loadEventCode(this.voucherHeadData.entityCode);
        }
      },
    },
    data() {
      return {
        voucherHeadData: {
          entityCode: '',
          eventCode: '',
        },
        applicationCodeOptions: [],
        billOptions: [],
        billDisabled: true,
        eventCodeDisabled: true,
        rules: {
          templateCode: [{ required: true, message: '请输入凭证模板编码', trigger: 'blur' }],
          eventCode: [{ required: true, message: '请输入单据事件名称', trigger: 'blur' }],
        },
        eventCodeOption: [],
      };
    },
    mounted() {
      this.loadOptions();
    },
    methods: {
      async loadOptions() {
        let list = await this.$baseRequest.functionalModList();
        let newArr = [];
        list.forEach((item) => {
          if (newArr.indexOf(item.applicationCode) === -1) {
            newArr.push(item.applicationCode);
            this.applicationCodeOptions.push({
              label: item.applicationName,
              value: item.applicationCode,
              enableFlag: item.enableFlag,
            });
          }
        });
      },
      async loadBill(val) {
        let options = [];
        await this.$axios
          .post('/maindata/dictData/listDataDictByDataType', { dictType: val })
          .then((res) => {
            options = res.data.data;
            options.forEach((item) => {
              this.billOptions.push({
                label: item.label,
                value: item.value,
                accountStatusCallback: item.remark,
              });
            });
            this.billDisabled = false;
          });
      },
      changeApplication(val) {
        this.billOptions = [];
        this.voucherHeadData.entityCode = '';
        this.loadBill(val);
      },
      submit() {
        let validate = '';
        this.$refs['voucherHeadData'].validate((valid) => {
          if (valid) {
            validate = true;
          } else {
            validate = false;
          }
          return valid;
        });
        return validate;
      },
      changeBill(val) {
        this.voucherHeadData.eventCode = '';
        this.loadEventCode(val);
      },
      loadEventCode(val) {
        this.eventCodeDisabled = false;
        this.eventCodeOption = [];
        this.$axios
          .post('/maindata/dictData/listDataDictByDataType', { dictType: val })
          .then((res) => {
            let options = res.data.data;
            options.forEach((data) => {
              let params = {
                value: data.value,
                label: data.label,
                enableFlag: data.dataStatus === 0 ? 'N' : 'Y',
              };
              this.eventCodeOption.push(params);
            });
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  .el-form-item {
    width: 25%;
    ::v-deep .el-form-item__label {
      width: 100px;
    }
    ::v-deep .el-form-item__content {
      margin-left: 100px;
    }
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor {
      width: 100%;
    }
  }
  .item {
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    line-height: 100px;
    align-items: center;
  }
</style>
